import gsap, { Power3 } from 'gsap'
import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Link } from 'react-router-dom'

const IndexGallery: React.FC = () => {
	const galleryRef = useRef<HTMLDivElement>(null)

	useLayoutEffect(() => {
		gsap.registerPlugin(ScrollTrigger)
		let idxGalleryCarousel = document.querySelector('.index-gallery--carousel') as HTMLDivElement

		let ctx = gsap.context(() => {
			gsap.to(idxGalleryCarousel, {
				x: `-${idxGalleryCarousel.scrollWidth - idxGalleryCarousel?.offsetWidth}`,
				ease: 'none',
				scrollTrigger: {
					trigger: '.timeline--container',
					start: 'bottom center',
					// markers: true,
					end: idxGalleryCarousel.offsetWidth < 600 ? 'bottom 75%' : 'bottom 65%',
					scrub: 4,
					invalidateOnRefresh: true,
					onEnter: function () {
						console.log('enter')
					},
				},
			})
		})

		return () => ctx.revert()
	}, [])

	return (
		<div className='index-gallery--container'>
			<div className='index-gallery--carousel' id='idx-gallery-carousel' ref={galleryRef}>
				<img src='/images/index-gallery/1.png' alt='' />
				<img src='/images/index-gallery/2.png' alt='' />
				<img src='/images/index-gallery/3.png' alt='' />
				<img src='/images/index-gallery/4.png' alt='' />
				<img src='/images/index-gallery/5.png' alt='' />
				<img src='/images/index-gallery/6.png' alt='' />
				<img src='/images/index-gallery/1.png' alt='' />
			</div>

			<Link to='gallery'>
				<div className='btn--index-gallery'>
					Check out gallery{' '}
					<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M4.16669 9.99996H15.8334M15.8334 9.99996L10 4.16663M15.8334 9.99996L10 15.8333'
							stroke='#101828'
							strokeWidth='2'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
					</svg>
				</div>
			</Link>
		</div>
	)
}

export default IndexGallery
